import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';
import { RiFileList2Line } from 'react-icons/ri';
import { toast } from 'react-toastify';

import api from '../../services/apiSgft';
import { TrainingControlAtom } from '../../state/TrainingControl.atom';
import { DateRangeDialog } from '../atoms/DateRangeDialog';
import LightTooltip from '../atoms/LightTooltip';

interface TrainingControlDownloadButtonProps {
	filteredData: TrainingControlAtom;
}

interface DateRange {
	start: string;
	end: string;
}

export const TrainingControlHistoryDownloadButton: React.FC<
	TrainingControlDownloadButtonProps
> = ({ filteredData }) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [dateRange, setDateRange] = useState<DateRange>({ start: '', end: '' });
	const [isEverything, setIsEverything] = useState(false);

	const handleDownload = async (includeDates: boolean) => {
		try {
			const params = {
				employee: filteredData.employee,
				role: filteredData.role,
				rmStatus: filteredData.rmStatus,
				training: filteredData.training,
				expirationStatus: filteredData.expirationStatus,
				validityStartDate: filteredData.timeRange.startDate,
				validityEndDate: filteredData.timeRange.endDate,
				pole: filteredData.pole,
				workstation: filteredData.workstation,
				management: filteredData.management,
				areaCoordinator: filteredData.areaCoordinator,
				onlineCompletionStatus: filteredData.onlineCompletionStatus,
				presencialCompletionStatus: filteredData.presencialCompletionStatus,
				trainingType: filteredData.trainingType,
				trainingPole: filteredData.trainingPole,
				...(includeDates &&
					!isEverything && {
						startDate: dateRange.start,
						endDate: dateRange.end,
					}),
			};
			const response = await api.get(`/extraction/training-control-history`, {
				params,
				responseType: 'blob',
			});
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Histórico de Treinamentos - SGFT.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (e: any) {
			let errorMessage = 'Erro ao baixar extração';

			if (e.response?.data instanceof Blob) {
				try {
					const text = await e.response.data.text();
					const errorData = JSON.parse(text);
					errorMessage = errorData.message || errorMessage;
				} catch (parseError) {
					console.error('Erro ao parsear resposta:', parseError);
				}
			} else if (e.response?.data?.message) {
				errorMessage = e.response.data.message;
			} else if (e.message) {
				errorMessage = e.message;
			}

			toast.error(errorMessage, {
				theme: 'colored',
				toastId: 'error',
			});
		} finally {
			setIsDialogOpen(false);
		}
	};

	return (
		<>
			<div className="cursor-pointer">
				<LightTooltip title="Extrair histórico">
					<IconButton onClick={() => setIsDialogOpen(true)}>
						<RiFileList2Line color="grey" fontSize={'1.6rem'} />
					</IconButton>
				</LightTooltip>
			</div>
			<DateRangeDialog
				title={`Selecionar Periodo do Histórico:`}
				dateRange={dateRange}
				setDateRange={setDateRange}
				isEverything={isEverything}
				setIsEverything={setIsEverything}
				isOpen={isDialogOpen}
				setIsOpen={setIsDialogOpen}
				onConfirmation={() => handleDownload(!isEverything)}
			/>
		</>
	);
};
